import { useSelector } from "react-redux";

import { getCourseSectionsDoNotExist } from "seneca-common/features/course/state";
import useRedirectOnCondition from "seneca-common/utils/hooks/routing/useRedirectOnCondition";

import { linkToAddCoursesPage } from "features/dashboard/pages/courses-page/links";

import { addRedirectedFromMissingCourseState } from "../links";

export default function useMissingCourseRedirect(courseId: string) {
  const courseDoesNotExist = useSelector((state: any) =>
    getCourseSectionsDoNotExist(state, courseId)
  );

  useRedirectOnCondition(
    courseDoesNotExist,
    addRedirectedFromMissingCourseState(linkToAddCoursesPage(), courseId)
  );
}
